module.exports = __webpack_public_path__ + "static/media/rocket.11218177.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/assets/rocket.svg
// module id = 329
// module chunks = 0